module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat1-f7cb9915b22ebe92d1343053f04d9d19.svg";